//import React, { Component } from "react";
import React, { useState, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  setSendSubProject,
  postSubprojects,
  setEditProjectsShow,
  setSubProjectStyle,
  setProjectToEdit,
  getSubprojectsType,
} from "../../../../store/actions/index";
import {
  openMainModal,
  closeMainModal,
  openEdifySpinner,
} from "../../../../store/actions/profileActions";
import RubroSelect from "./RubroSelect";
import styles from "./NuevoSubproyecto.module.scss";
import { ReactComponent as Link } from "../../../../assets/svg/linkPlaceholder.svg";
import { ReactComponent as AddDescription } from "../../../../assets/svg/addDescriptionPlaceholder.svg";
import { ReactComponent as Cotizacion } from "../../../../assets/svg/cotizacionPlaceholder.svg";
import { ReactComponent as DateIcon } from "../../../../assets/svg/datePlaceholder1.svg";
import { ReactComponent as Plus } from "../../../../assets/svg/plus.svg";
import { ReactComponent as Trash } from "../../../../assets/svg/description-sub.svg";
import { fireAnalytics } from "../../../../utils/firebase";


const NuevoSubproyecto = ({
  subProjectsType,
  subProjectId,
  setSubProjectStyle,
  setSendSubProject,
  setEditProjectsShow,
  projectToEdit,
  userId,
  closeModal,
  ...props
}) => {
  const [fileName, setFileName] = useState("");
  const [clear, setClear] = useState(false);
  const [isFormHidden, setIsFormHidden] = useState(false);
  const history = useHistory();

  const resetClear = () => {
    setClear(false);
  };

  const addHandler = (values, initialValues, resetForm) => {
    let { projectIdForSub, isEditing } = props;
    fireAnalytics("add_subproject", { category: "publishing" });
    if (isEditing) {
      setSendSubProject(values);
      props.postSubprojects(values, projectIdForSub, isEditing, closeModal);
      setProjectToEdit(projectIdForSub);
      resetForm(initialValues);
      resetClear();
      props.closeMainModal();

    } else {
      setSendSubProject(values, subProjectId);
      props.postSubprojects(values, projectIdForSub, isEditing, closeModal, history);
      setProjectToEdit(projectIdForSub);
      resetForm(initialValues);
      resetClear();
      setEditProjectsShow(false);
      props.closeMainModal();
    }
  };


  //Cambia el estilo del formulario paso 1

  useEffect(() => {
    if (props.showEditProject) {
      setIsFormHidden(true);
    } else {
      setIsFormHidden(false);
    }
  }, [props.showEditProject]);


  //Validación del formulario de carga

  const subProyectosSchema = Yup.object().shape({
    nameSub: Yup.string().test(
      "is-empty",
      "El campo está vacío",
      function (valor) {
        return typeof valor === "string" && valor.trim() !== "";
      }
    ),

    descriptionSub: Yup.string().test(
      "is-empty",
      "*Si no proporciona una descripción puede que la cotización recibida no sea precisa",
      function (valor) {
        return typeof valor === "string" && valor.trim() !== "";
      }
    ),

    linkSub: Yup.string().test(
      "is-empty",
      "*Si no proporciona un link de documentación puede que la cotización recibida no sea precisa",
      function (valor) {
        return typeof valor === "string" && valor.trim() !== "";
      }
    ),

    endDateSub: Yup.date().test(
      "is-empty",
      "*Si no proporciona una fecha de cierre el usuario no sabrá hasta cuándo puede enviar la cotización",
      function (valor) {
        return typeof valor === "string" && valor.trim() !== "";
      }
    ),
  });

  return (
    <div className={styles.generalContainer}>
      <Formik
        initialValues={{
          nameSub: "",
          descriptionSub: "",
          linkSub: "",
          startDateSub: "",
          endDateSub: "",
          file: null,
          excel: null,
        }}
        validationSchema={subProyectosSchema}
      >
        {({
          handleSubmit,
          isEditing,
          values,
          resetForm,
          initialValues,
          setFieldValue,
          history,
        }) => (
          <Form onSubmit={handleSubmit}>
            <div className={`${styles.fieldWrapperSubProyect} `}>
              <RubroSelect
                inputName="nameSub"
                rubros={subProjectsType}
                setFieldValue={setFieldValue}
                clear={setClear}
                resetClear={props.resetClear}
              />
            </div>
            <div className={values.nameSub ? styles.containerSubproject : ""}>
              <div
                className={
                  props.subProjectStyleForm
                    ? styles.fieldWrapper_hidden
                    : `${styles.fieldWrapper_content} ${values.nameSub && styles.open
                    }`
                }
              >
                <h3 className={styles.tituloRubro}>
                  {values.nameSub.split("*")[1]}
                </h3>
                <div className={styles.tituloDescripcion}>
                  <AddDescription />
                  <h4>Descripción</h4>
                </div>
                <div className={styles.fieldWrapper}>
                  <div className={styles.relative}>
                    <Field
                      id="descriptionSub"
                      name="descriptionSub"
                      placeholder="Añade una breve descripción."
                      as="textarea"
                    />
                  </div>
                </div>
                <div className={styles.tituloLink}>
                  <Link />
                  <h4>Link de acceso a la documentación</h4>
                </div>
                <div className={styles.fieldWrapperLink}>
                  <div className={styles.relative}>
                    <Field
                      className={styles.textAreaLink}
                      id="linkSub"
                      name="linkSub"
                      placeholder="Google Drive, Dropbox, etc."
                    />
                  </div>
                </div>
                <div className={props.isEditing ? styles.fechasWrapper_edit : styles.fechasWrapper}>
                  <div className={styles.fieldWrapper_startDateInput}>
                    <div className={styles.fieldWrapper_dateTitle}>
                    <DateIcon className={styles.fieldWrapper_dateIcon} />
                    <h5 className={styles.fechaCierre}>
                      ¿Desde cuándo deseas recibir cotizaciónes?
                    </h5>
                    </div>
                    <div className={styles.fieldWrapper_dateInputContainer}>
                    <Field
                      type="date"
                      id="startDateSub"
                      name="startDateSub"
                      className={styles.fieldWrapper_startDateInputPlaceholder}
                      readOnly={false}                     
                    />
                    </div>
                  </div>
                  <div className={styles.fieldWrapper_endDateInput}>
                    <div className={styles.fieldWrapper_dateTitle}>
                    <DateIcon className={styles.fieldWrapper_dateIcon} />
                    <h5 className={styles.fechaCierre}>
                      ¿Hasta cuándo deseas recibir cotizaciónes?
                    </h5>
                    </div>
                    <div className={styles.fieldWrapper_dateInputContainer}>
                    <Field
                      type="date"
                      id="endDateSub"
                      name="endDateSub"
                      placeholder="Seleccionar fecha"
                      className={styles.fieldWrapper_endDateInputPlaceholder}
                      readOnly={false}
                    />
                    </div>
                  </div>
                </div>
                <div className={styles.tituloPlanilla}>
                  <Cotizacion />
                  <h4>Planilla modelo de cotización</h4>
                </div>
                <div className={styles.fieldWrapperPlanilla_container}>
                  <label
                    htmlFor="fileType"
                    className={styles.fieldWrapperPlanilla}
                  >
                    <p className={styles.fieldWrapperPlanilla_placeHolder}>
                      {fileName === ""
                        ? "Click para seleccionar un archivo"
                        : fileName.substring(0, 40) + "..."}
                    </p>
                    <Field
                      className={styles.fileName}
                      id="fileType"
                      name="fileType"
                      type="file"
                      accept=".pdf, .xlsx, .xls"
                      onChange={(event) => {
                        event.currentTarget.files[0] &&
                          setFieldValue("file", event.currentTarget.files[0]);
                        setFileName(event.currentTarget.files[0]?.name);
                      }}
                    />
                  </label>
                </div>
                <div className={styles.buttonContainer}>
                  <button
                    className={`${styles.subbutton} ${styles.delete}`}
                    onClick={() => {
                      resetForm(initialValues);
                      setClear(true);
                    }}
                  >
                    {" "}
                    <span className={styles.trash}>
                      <Trash />{" "}
                    </span>
                    Cancelar
                  </button>
                  <button
                    className={styles.subbutton}
                    onClick={() => {
                      props.isEditing
                        ? setSubProjectStyle(false)
                        : setSubProjectStyle(true);
                      addHandler(values, initialValues, resetForm, history);
                      setFileName("");
                    }}
                  >
                    <span className={styles.trash}>
                      <Plus />{" "}
                    </span>{" "}
                    Agregar rubro
                  </button>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    userId: state.general.userData.id,
    subProjectsType: state.profile.subProjectsType,
    showEditProject: state.profile.editProjectsShow,
    subProjectId: state.profile.subProjectId,
    subProjectStyleForm: state.profile.styleForm,
    projectToEdit: state.profile.projectToEdit,
  };
};

export default connect(mapStateToProps, {
  setSendSubProject,
  setEditProjectsShow,
  setSubProjectStyle,
  postSubprojects,
  setProjectToEdit,
  openMainModal,
  closeMainModal,
  openEdifySpinner,
  getSubprojectsType,
})(NuevoSubproyecto);
